import service from './api.services';

const buscarEtapaMRA = async (idProcesso) => {
    const response = await service.get(`/api/etapa-mra/${idProcesso}`);
    return response.data;
};

const salvar = async (idProcesso, etapaMRA) => {
    const response = await service.post(`/api/etapa-mra/${idProcesso}`, etapaMRA);
    return response.data;
};

export {
    buscarEtapaMRA,
    salvar
};
